module.exports = __webpack_public_path__ + "static/media/dinner.35a3c9ac.jpg";